module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9YtwEC/tc-custom/9781035825073.jpg?1716662258078",
      "alt": "This image is the cover for the book Heart to Let"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Heart to Let\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Volume 2 of this quartet follows the fortunes of its heroine, Amy Spencer. After the sudden death of Rupert, who rescued her from obscurity, she is faced with having to move from London, where she was a partner in a prestigious firm of solicitors, to a small town in the home counties and seek work as an assistant solicitor. Here, she meets Jack, a very different character, and her personal and professional life moves in a very different direction. Does she find happiness? Read the book and find out...")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mary Simpson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Mary Simpson (known to her friends as ‘Champagne Mary’) retired after a career in law spanning over 40 years. After retirement, she attained a degree with merit in creative writing and then an MA in creative writing, also with merit. In addition to her first novel of this quartet, she has had several collections of poetry published. Apart from her writing, her interests are in wine and the theatre. This quartet spans seven decades in the life of its heroine, who was born during the Battle of Britain.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0